import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DocumentIcon from '@material-ui/icons/InsertDriveFile';
import LinkIcon from '@material-ui/icons/Link';
import Paper from '@material-ui/core/Paper';

import Icon from '@components/Icon/Icon';
import Link from '@components/Link/Link';
import SectionSeparator from '../../components/SectionSeparator/SectionSeparator';

import {
  documentsList,
  linksList,
  paragraphsList,
} from '@selectors/caseDetails';

import './AdditionalInformation.scss';

const AdditionalInformation = ({
  documents,
  links,
  paragraphs,
}) => (
  <div>
    {(document.length > 0 || links.length > 0 || paragraphs.length > 0) && (
      <React.Fragment>
        <SectionSeparator title="Additional Information" />
        <Paper className="additional-information">
          {paragraphs.map(({
            id,
            text,
          }) => (
            <p
              className="additional-information__paragraph"
              key={id}
            >
              {text}
            </p>
          ))}
          <div className="additional-information__columns">
            {(documents.length > 0) && (
              <div className="additional-information__section">
                <div className="additional-information__section-header">
                  Documents:
                </div>
                {documents.map(({
                  id,
                  link,
                  title,
                }) => (
                  <div
                    className="additional-information__section-wrapper"
                    key={id}
                  >
                    <div className="additional-information__section-icon">
                      <Icon>
                        <DocumentIcon />
                      </Icon>
                    </div>
                    <div>
                      <Link href={link}>
                        {title}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {(links.length > 0) && (
              <div className="additional-information__section">
                <div className="additional-information__section-header">
                  Links:
                </div>
                {links.map(({
                  id,
                  link,
                  title,
                }) => (
                  <div
                    className="additional-information__section-wrapper"
                    key={id}
                  >
                    <div className="additional-information__section-icon">
                      <Icon>
                        <LinkIcon />
                      </Icon>
                    </div>
                    <div>
                      <Link href={link}>
                        {title}
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Paper>
      </React.Fragment>
    )}
  </div>
);

AdditionalInformation.propTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    link: PropTypes.string,
    title: PropTypes.string,
  })).isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    link: PropTypes.string,
    title: PropTypes.string,
  })).isRequired,
  paragraphs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
  })).isRequired,
};

const mapStateToProps = state => ({
  documents: documentsList(state),
  links: linksList(state),
  paragraphs: paragraphsList(state),
});

export default connect(mapStateToProps)(AdditionalInformation);



// WEBPACK FOOTER //
// ./src/routes/Case/Details/containers/AdditionalInformation/AdditionalInformation.js